import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, PagingResponseModel, ApiVisa, Pagination, BasicApiResponseModel} from '../../shared';
import {MembershipCardClassContainerModel, MembershipCardContainerModel} from '../../../../../../models/aggregates/crm/membership';
import {Core2Config} from '../../shared';
import { MembershipCardQueryCriteriaClass, MembershipCardCriteriaModelQuery } from '../../../criteria/membership-card-query-criteria.model';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class MembershipCardService extends BaseApiPublicLoginTemplateService<MembershipCardContainerModel, MembershipCardContainerModel, MembershipCardContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership-cards';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership-cards';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership-cards';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership-cards/' + BaseApiTemplateService.LOGIN_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership-cards/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }


  getMembershipCardByCriteria(visa: ApiVisa, criteria?: MembershipCardQueryCriteriaClass):
  Observable<PagingResponseModel<MembershipCardContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildEntityCriteriaCriteria = new MembershipCardCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<MembershipCardContainerModel>>(this.apiUrl + '/query?' +
    buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));

  }
  getByLoginSubjectGuid(loginSubjectGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/query?login_subject_guid=' + loginSubjectGuid;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getMembershipCardClassByCriteriaLogin(pagination: Pagination, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/login-entity-ep/membership-class/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MembershipCardClassContainerModel>>(
      url, this.getHttpHeader(apiVisa)
    );
  }

  getMembershipCardClassByGuidLogin(guid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/login-entity-ep/membership-class/' + guid;
    return this.httpClient.get<PagingResponseModel<MembershipCardClassContainerModel>>(
      url, this.getHttpHeader(apiVisa)
    );
  }

  getMembershipCardClassLogin(apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/login-entity-ep/membership-class';
    return this.httpClient.get<PagingResponseModel<MembershipCardClassContainerModel>>(
      url, this.getHttpHeader(apiVisa)
    );
  }
}


